'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Content;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _Interests = require('./Interests');

var _Skills = require('./Skills');

var _EducationLevels = require('./EducationLevels');

var _Jobs = require('./Jobs');

var _Next = require('./Next');

var _Next2 = _interopRequireDefault(_Next);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLASS_NAME = 'content';

function Content(_ref) {
  var currentCategory = _ref.currentCategory,
      interests = _ref.interests,
      skills = _ref.skills,
      educationLevels = _ref.educationLevels,
      changeInterestValue = _ref.changeInterestValue,
      changeSkill = _ref.changeSkill,
      changeEducation = _ref.changeEducation,
      changeCategory = _ref.changeCategory,
      sectionLabels = _ref.sectionLabels,
      jobs = _ref.jobs,
      loadingJobs = _ref.loadingJobs,
      jobLimit = _ref.jobLimit;

  var content = void 0;
  var next = _react2.default.createElement(_Next2.default, {
    handleClick: changeCategory
  });
  if (currentCategory === 'interests') {
    content = _react2.default.createElement(_Interests.Interests, {
      interests: interests,
      onChange: changeInterestValue,
      label: sectionLabels.interests
    });
  } else if (currentCategory === 'skills') {
    content = _react2.default.createElement(_Skills.Skills, {
      skills: skills,
      label: sectionLabels.skills,
      onChange: function onChange(id) {
        changeSkill(id);
      }
    });
  } else if (currentCategory === 'education') {
    content = _react2.default.createElement(_EducationLevels.EducationLevels, {
      educationLevels: educationLevels,
      label: sectionLabels.education,
      onChange: function onChange(val) {
        changeEducation(val);
      }
    });
  } else {
    jobLimit = typeof jobLimit === 'number' ? jobLimit : jobs.length;
    content = _react2.default.createElement(_Jobs.Jobs, {
      jobs: jobs,
      loading: loadingJobs,
      jobLimit: jobLimit
    });

    next = _react2.default.createElement(
      'div',
      { className: 'job-results' },
      _react2.default.createElement(
        'p',
        null,
        jobLimit,
        ' of ',
        jobs.length,
        ' JOBS'
      ),
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/matching-jobs' },
        'See More Job Matches'
      )
    );
  }

  return _react2.default.createElement(
    'div',
    { className: CLASS_NAME },
    content,
    next
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Matcher/components/Content.jsx
// module id = 1227
// module chunks = 0